import { useQuery } from '@tanstack/react-query';
import { coachingTierLabels, type CoachingTier } from '@mlm/shared';
import { getTenantFeatures } from './api';

/**
 * What the coaching tiers are called on this tenant (`coaching.tier_labels`,
 * Settings -> Coaching), with the defaults until the config has loaded. The
 * keys `pro` / `elite` stay the identifiers everywhere; only the words change.
 */
export function useCoachingTierLabels(): Record<CoachingTier, string> {
  const q = useQuery({
    queryKey: ['tenant-features'],
    queryFn: getTenantFeatures,
    staleTime: 60_000,
  });
  return coachingTierLabels(q.data?.coaching);
}
